import React from 'react';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import GoogleOneTap from '../GoogleOneTapComponent/GoogleOneTapComponent';

class MainComponent extends React.Component {
    render() {
        return (
            <React.Fragment>
                <ErrorBoundary>
                    <GoogleOneTap {...this.props} />
                </ErrorBoundary>
            </React.Fragment>
        );
    }
}

export default MainComponent;
